import { AvField, AvForm } from "availity-reactstrap-validation";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button, Card, CardBody, Col, Label, Row } from "reactstrap";
import api from "../../services/api";
import { setBreadcrumbItems } from "../../store/actions";

const AddCourseProgramName = (props) => {
    const navigate = useNavigate();
    document.title = "Technical Hub | Add Course Program Name";

    const backendUrl = process.env.REACT_APP_BACKEND_URL || "";

    const breadcrumbItems = [
        { title: "Technical Hub", link: "#" },
        { title: "Course Program Names", link: "#" },
        { title: "Add Course Program Name", link: "#" },
    ];

    const [courses, setCourses] = useState([]);
    const [passoutYears, setPassoutYears] = useState([]);

    const [selectedCourse, setSelectedCourse] = useState(null);
    const [selectedTechnology, setSelectedTechnology] = useState(null);
    const [selectedPassoutYears, setSelectedPassoutYears] = useState(null);

    const [addedby, setAddedBy] = useState("admin");

    // ---------------------------------------------
    // INITIAL LOAD
    // ---------------------------------------------
    useEffect(() => {
        try {
            const curr_user = JSON.parse(localStorage.getItem("authUser"));
            if (curr_user?.first_name) {
                setAddedBy(curr_user.first_name);
            }
        } catch { }

        getCourses();
        getPassoutYears();

        if (props?.setBreadcrumbItems) {
            props.setBreadcrumbItems("Course Program Names", breadcrumbItems);
        }
    }, []);

    // ---------------------------------------------
    // GET COURSES
    // ---------------------------------------------
    const getCourses = async () => {
        try {
            const res = await axios.get(`${backendUrl}get-courses`);
            if (res.status === 200) {
                setCourses(res.data || []);
            }
        } catch (err) {
            console.error("Error fetching courses:", err);
            toast.error("Failed to load courses.");
        }
    };

    // ---------------------------------------------
    // GET PASSOUT YEARS
    // ---------------------------------------------
    const getPassoutYears = async () => {
        try {
            const res = await axios.get(`${backendUrl}get-passout_year`);
            if (res.status === 200) {
                console.log(res.data)
                setPassoutYears(res.data || []);
            }
        } catch (err) {
            console.log(err);
            toast.error("Failed to load passout years.");
        }
    };
    const allowedRegex = /^[a-zA-Z0-9\s.-]*$/;

   
    // ---------------------------------------------
    // OPTIONS
    // ---------------------------------------------
    const courseOptions = courses.map((c) => ({
        label: c.course_name,
        value: c._id,
    }));

    const passoutOptions = passoutYears.map((y) => ({
        label: y.label,
        value: y.value,
    }));

    // ---------------------------------------------
    // SUBMIT HANDLER
    // ---------------------------------------------
    const handleSubmit = async (event, values) => {
        if (!selectedCourse?.value) {
            toast.error("Please select a course.");
            return;
        }
        if (!selectedPassoutYears?.value) {
            toast.error("Please select a passout year.");
            return;
        }
        if (!values.programName || values.programName.trim() === "") {
            toast.error("Please enter program name.");
            return;
        }

        const payload = {
            course_id: selectedCourse.value,
            program_name: values.programName,
            passout_year: selectedPassoutYears.value,
            added_by: addedby,
        };

        try {
            const res = await api.post(`${backendUrl}create-course-program-name`, payload);

            if (res.status === 200 || res.status === 201) {
                toast.success(res.data.message || "Program name added successfully!");
                setTimeout(() => navigate("/course-program-names-list"), 1000);
            } else {
                toast.error("Unexpected server response.");
            }
        } catch (err) {
            console.error("Error adding program name:", err);

            if (err.response?.data?.message) {
                toast.error(err.response.data.message);
            } else {
                toast.error("Something went wrong. Please try again.");
            }
        }
    };

    // ---------------------------------------------
    // UI
    // ---------------------------------------------
    return (
        <React.Fragment>
            <Row>
                <ToastContainer transition={Bounce} />

                <Col xl="12">
                    <Card>
                        <CardBody>
                            <h4 className="card-title">Add Course Program Name</h4>

                            <AvForm onValidSubmit={handleSubmit}>
                                <Row>
                                    <Col md="4">
                                        <Label>Select Course *</Label>
                                        <Select
                                            value={selectedCourse}
                                            onChange={setSelectedCourse}
                                            options={courseOptions}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            }}
                                        />
                                    </Col>


                                    <Col md="4">
                                        <Label>Select Passout Year *</Label>
                                        <Select
                                            value={selectedPassoutYears}
                                            onChange={setSelectedPassoutYears}
                                            options={passoutOptions}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            }}
                                        />
                                    </Col>

                           
                                    <Col md="4">
                                        <Label>Program Name *</Label>
                                        <AvField
                                            name="programName"
                                            type="text"
                                            validate={{
                                                required: {
                                                    value: true,
                                                    errorMessage: "Enter program name",
                                                },
                                            }}

                                            onKeyDown={(e) => {
                                                const key = e.key;

                                                // Block characters not in allowedRegex
                                                if (
                                                    !allowedRegex.test(key) &&
                                                    key.length === 1
                                                ) {
                                                    e.preventDefault();
                                                }
                                            }}

                                            onPaste={(e) => {
                                                const paste = e.clipboardData.getData("text");
                                                if (!allowedRegex.test(paste)) {
                                                    e.preventDefault();
                                                }
                                            }}

                                            maxLength="25"
                                        />
                                    </Col>
                                </Row>

                                <Button color="primary" type="submit" className="mt-3">
                                    Submit
                                </Button>
                            </AvForm>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default connect(null, { setBreadcrumbItems })(AddCourseProgramName);
